export default {
    enable: Boolean,
    onLabel: String,
    offLabel: String
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/ObsoleteSwitchProps.js